<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form class="contact-edit onsip-grid-placement" [formGroup]="form" (ngSubmit)="save()">
    <div class="first-column">
      <h1>Address</h1>
      <section class="form-control-wrapper with-mat-form-field">
        <div class="mat-body-1">{{ "ONSIP_I18N.COMPANY" | translate }}</div>
        <mat-form-field appearance="outline" class="form-control">
          <input matInput required autocomplete="name" formControlName="organization" />
          <mat-error>{{ getNameError("organization") }}</mat-error>
        </mat-form-field>
      </section>

      <section class="form-control-wrapper with-mat-form-field">
        <div class="mat-body-1">{{ "ONSIP_I18N.STREET_ADDRESS" | translate }}</div>
        <mat-form-field appearance="outline" class="form-control">
          <input
            matInput
            onsipAddressValidator
            autocomplete="street-address"
            formControlName="address"
          />

          @for (error of form.controls.address.errors | keyvalue; track error) {
          <mat-error>
            {{ error.value.message }}
          </mat-error>
          }
        </mat-form-field>
      </section>

      <section class="form-control-wrapper with-mat-form-field">
        <div class="mat-body-1">{{ "ONSIP_I18N.CITY" | translate }}</div>
        <mat-form-field appearance="outline" class="form-control">
          <input matInput onsipCityValidator autocomplete="address-level2" formControlName="city" />
          @for (error of form.controls.city.errors | keyvalue; track error) {
          <mat-error>
            {{ error.value.message }}
          </mat-error>
          }
        </mat-form-field>
      </section>

      <span class="two-forms">
        <section class="form-control-wrapper with-mat-form-field">
          <div class="mat-body-1">{{ "ONSIP_I18N.STATE" | translate }}</div>
          <mat-form-field
            appearance="outline"
            class="form-control contact-edit__select-wrap"
            onsip-form-field-infix-auto
          >
            <!-- HACK for autocompleting state form field -->
            <input
              class="hide-for-autocomplete"
              type="text"
              name="state"
              [formControl]="autoCompleteState"
              autocomplete="address-level1"
            />
            <mat-select onsipStateValidator formControlName="state">
              @for (state of listOfStates; track state) {
              <mat-option [value]="state[1]">
                {{ state[1] }}
              </mat-option>
              }
            </mat-select>
            @for (error of form.controls.state.errors | keyvalue; track error) {
            <mat-error>
              {{ error.value.message }}
            </mat-error>
            }
          </mat-form-field>
        </section>
        <section class="form-control-wrapper with-mat-form-field">
          <div class="mat-body-1">{{ "ONSIP_I18N.POSTAL_CODE" | translate }}</div>
          <mat-form-field appearance="outline" class="form-control" onsip-form-field-infix-auto>
            <input
              matInput
              onsipZipCodeValidator
              autocomplete="postal-code"
              formControlName="zipcode"
            />
            @for (error of form.controls.zipcode.errors | keyvalue; track error) {
            <mat-error>
              {{ error.value.message }}
            </mat-error>
            }
          </mat-form-field>
        </section>
      </span>
    </div>
    <div class="second-column">
      <h1>Contact</h1>
      <section class="form-control-wrapper with-mat-form-field">
        <div class="mat-body-1">{{ "ONSIP_I18N.CONTACT_NAME" | translate }}</div>
        <mat-form-field appearance="outline" class="form-control">
          <input matInput required autocomplete="name" formControlName="name" />
          <mat-error>{{ getNameError("name") }}</mat-error>
        </mat-form-field>
      </section>

      <section class="form-control-wrapper with-mat-form-field">
        <div class="mat-body-1">{{ "ONSIP_I18N.EMAIL" | translate }}</div>
        <mat-form-field appearance="outline" class="form-control">
          <input matInput required autocomplete="email" formControlName="email" />
          <mat-error>{{ getEmailError() }}</mat-error>
        </mat-form-field>
      </section>
      <section class="form-control-wrapper with-mat-form-field">
        <div class="mat-body-1">{{ "ONSIP_I18N.PHONE_NUMBER" | translate }}</div>
        <mat-form-field appearance="outline" class="form-control">
          <input matInput required autocomplete="tel" formControlName="phone" />
          <mat-error>{{ getPhoneError() }}</mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="contact-edit__controls">
      <button mat-button color="primary" type="button" (click)="cancel()">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit">
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
